/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2022-12-27 17:24:07
 * @LastEditors: linxi
 * @LastEditTime: 2025-02-13 16:00:16
 */

import { nanoid, unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
  Space,
} from 'antd'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectUserId } from '../../app/applicationSlice'
import { RootDispatch } from '../../app/store'
import styles from './AiTuning.module.css'
import {getAIDetailAsync, getAIDetailSubmitAsync, getAIListAsync, getAIRecordDetailAsync} from './AiTuningSlice'
import TextArea from "antd/lib/input/TextArea";

interface configurationModelProps {
  id:number
  visible: boolean
  onCancel: () => void
  onOk: () => void
}
export const DetailModel = ({
  id,
  visible,
  onCancel,
  onOk,
}: configurationModelProps): ReactElement => {
  const userId = useSelector(selectUserId)
  const dispatch = useDispatch<RootDispatch>()

  const [m,setM] = useState<any>([])

  const [mConfig,setMConfig] = useState<any>([])
  function getBusinessTypeDescription(m:any) {
    switch (m) {
      case 10:
        return "西医病历生成";
      case 11:
        return "中医病历生成";
      case 20:
        return "病历检查";
      case 30:
        return "病历推理";
      default:
        return "其他";
    }
  }
  useEffect(() => {
    if (visible && id) {
      dispatch(getAIRecordDetailAsync({ id }))
        .then(unwrapResult)
        .then((res: any) => {
          setM(res);
          const mconfig = JSON.parse(res.modelConfig);
          setMConfig(mconfig)
        })
        .catch((ex) => {
          notification.error({
            message: "获取数据失败："+ex.message,
            duration: 3,
          });
          onCancel();
        })
    }
  }, [visible,id])


  return (
    <>
      <Modal
        title='对话详情'
        width={800}
        visible={visible}
        onCancel={() => {
          onCancel()
        }}
        onOk={() => {
          onOk()
        }}
        centered
        footer={null}
      >
        <div>
          <p style={{fontSize:"16px"}}>机构名称：{m.tenantName}，模型版本：{m.modelName}，接口耗时：{m.apiCost}毫秒，业务类型：{getBusinessTypeDescription(m.businessType)}</p>
          <p style={{fontSize:"16px"}}>提问：</p>
          <TextArea value={m.reqContent} autoSize ></TextArea>
          <p style={{fontSize:'16px',marginTop:"10px"}}>回答：</p>
          <TextArea value={m.resContent} autoSize ></TextArea>
          <p style={{fontSize:'16px',marginTop:"10px"}}>模型参数：</p>
          <span>温度系数：{mConfig.temperature}，topP解码策略：{mConfig.topP}，频率惩罚系数：{mConfig.frequencyPenalty}，存在惩罚系数：{mConfig.presencePenalty}</span>
        </div>

        <Row
            style={{
              marginTop:"50px",
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
        >
          <Button type='primary' onClick={() =>onCancel()}>
            关闭
          </Button>
        </Row>
      </Modal>
    </>
  )
}
